import React, { useEffect } from 'react';
import * as THREE from 'three';
import { isMobileDevice } from "../../utils/DeviceDetector";

const isMobile = isMobileDevice();


import { GUI } from 'three/examples/jsm/libs/dat.gui.module';
const createDatGui = function(obj, folderName, meshes){
    if (!window.DATGUI_DEFINED){
        var guiDiv = document.createElement('div');
        guiDiv.style.zIndex = 99;
        guiDiv.style.position = 'fixed';
        guiDiv.style.top = '0px';
        var bod = document.getElementsByTagName('body')[0];
        bod.appendChild(guiDiv);

        const gui = new GUI({autoPlace:false});
        window.gui = gui;
        // gui.close();
        // var cont = document.getElementById('datgui');
        guiDiv.appendChild(gui.domElement);
        window.DATGUI_DEFINED = true;

    }
    const folder = gui.addFolder(folderName);

    // const folder1 = gui.addFolder('folder1');

    // folder1.add(obj.material.uniforms.lacunarity, 'value').name('lacunarity x').min(0).max(10).step(0.001);
    // folder1.add(obj.material.uniforms.gain, 'value').name('gain y').min(0).max(10).step(0.001);
    // folder1.add(obj.material.uniforms.magnitude, 'value').name('magnitude z').min(0).max(10).step(0.001);

    folder.add(obj, 'similarity').name('similarity').min(-2).max(2).step(0.001).onChange((val)=>{
        meshes.forEach((mesh)=>{
            if(mesh)
                mesh.material.uniforms.similarity.value = val;
        })
    })
    folder.add(obj, 'spill').name('spill').min(-2).max(2).step(0.001).onChange((val)=>{
        meshes.forEach((mesh)=>{
            if(mesh)
                mesh.material.uniforms.spill.value = val;
        })
    })
    folder.add(obj, 'smoothness').name('smoothness').min(-2).max(2).step(0.001).onChange((val)=>{
        meshes.forEach((mesh)=>{
            if(mesh)
                mesh.material.uniforms.smoothness.value = val;
        })
    })

}



const createVidDom = function (src, scene, vidMesh) {
  var video = document.createElement('video');
  video.addEventListener('loadeddata', () => {
    scene.add(vidMesh);
  })
  video.src = src;
  video.setAttribute('webkit-playsinline', '');
  video.crossOrigin = 'anonymous';
  video.setAttribute('playsinline', '');
  video.setAttribute('loop', 'loop');
  // video.setAttribute('autoplay', 'false');
  video.muted = true;
  return video;
}




export default function GreenScreenedVid({ scene,src, addToRenderLoop, removeFromRenderLoop, similarity=0.3, smoothness=0.03, spill=0.5 }) {
  useEffect(() => {
    const ChromaKeyMaterial = function (width, height, keyColor) {
      THREE.ShaderMaterial.call(this);
      this.setValues({
        uniforms: {
          tex: {
            value: null
          },
          keyColor: {
            value: new THREE.Color(keyColor)
          },
          texWidth: {
            value: width
          },
          texHeight: {
            value: height
          },
          similarity: {
            value: similarity
          },
          smoothness: {
            value: smoothness
          },
          spill: {
            value: spill
          }

        },
        vertexShader: `	varying vec2 vUv;
    
         void main() {
             vUv = uv;
             gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
         }`,
        fragmentShader: `        uniform sampler2D tex;
         uniform float texWidth;
         uniform float texHeight;
    
         uniform vec3 keyColor;
         uniform float similarity;
         uniform float smoothness;
         uniform float spill;
                 
                 varying vec2 vUv;
    
         // From https://github.com/libretro/glsl-shaders/blob/master/nnedi3/shaders/rgb-to-yuv.glsl
         vec2 RGBtoUV(vec3 rgb) {
           return vec2(
             rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,
             rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5
           );
         }
    
         vec4 ProcessChromaKey(vec2 texCoord) {
           vec4 rgba = texture2D(tex, texCoord);
           float chromaDist = distance(RGBtoUV(texture2D(tex, texCoord).rgb), RGBtoUV(keyColor));
    
           float baseMask = chromaDist - similarity;
           float fullMask = pow(clamp(baseMask / smoothness, 0., 1.), 1.5);
           rgba.a = fullMask;
    
           float spillVal = pow(clamp(baseMask / spill, 0., 1.), 1.5);
           float desat = clamp(rgba.r * 0.2126 + rgba.g * 0.7152 + rgba.b * 0.0722, 0., 1.);
           rgba.rgb = mix(vec3(desat, desat, desat), rgba.rgb, spillVal);
    
           return rgba;
         }
    
         void main(void) {
           vec2 texCoord = vUv;
           gl_FragColor = ProcessChromaKey(texCoord);
         }`,

        transparent: true,
        opacity: 0
      });

    } // ChromakeyMaterial
    ChromaKeyMaterial.prototype = Object.create(THREE.ShaderMaterial.prototype);
    
    
    var geometry = new THREE.PlaneGeometry(20, 20);
    geometry.scale(- 1, 1, 1);
    
    var material = new ChromaKeyMaterial(1280, 720, 0x00ff00);
    var vidMesh = new THREE.Mesh(geometry, material);
    vidMesh.position.x = -9.999
    vidMesh.rotation.y = -Math.PI / 2;

    const video = createVidDom(src, scene, vidMesh);
    video.play();

    var texture = new THREE.VideoTexture(video);
    vidMesh.material.uniforms.tex.value = texture;


    var datGuiDebugObj = {
      similarity: .3,
      smoothness: 0.03,
      spill: 0.5
  }

  // createDatGui(datGuiDebugObj, 'params', [vidMesh])


    
    const id = addToRenderLoop();
    return () => {
      removeFromRenderLoop(id);
      scene.remove(vidMesh);
    }
  }, [])

  return (
    <>
    </>
  )
}
